import { __makeTemplateObject } from "tslib";
import styled, { css } from 'styled-components';
var flexDirection = {
    top: 'column',
    bottom: 'column-reverse',
    left: 'row',
    right: 'row-reverse',
};
export var Layout = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex: 1;\n  flex-direction: ", ";\n  min-height: 0;\n  min-width: 0;\n"], ["\n  display: flex;\n  flex: 1;\n  flex-direction: ", ";\n  min-height: 0;\n  min-width: 0;\n"])), function (props) { return flexDirection[props.legendPosition]; });
export var TitleSocket = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 0;\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 0;\n"])));
export var LegendSocket = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n\n  ", "\n\n  ", ";\n\n  ", ";\n\n  ", "\n"], ["\n  display: flex;\n\n  ",
    "\n\n  ",
    ";\n\n  ",
    ";\n\n  ",
    "\n"])), function (props) {
    return (props.position === 'top' || props.position === 'bottom') &&
        props.layout === 'vertical' && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      max-height: 30%;\n    "], ["\n      max-height: 30%;\n    "])));
}, function (props) {
    return props.position === 'right' && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      margin-left: 15px;\n    "], ["\n      margin-left: 15px;\n    "])));
}, function (props) {
    return props.position === 'left' && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      margin-right: 15px;\n    "], ["\n      margin-right: 15px;\n    "])));
}, function (props) {
    return (props.position === 'left' || props.position === 'right') && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      max-width: 25%;\n    "], ["\n      max-width: 25%;\n    "])));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
